import React from 'react';
import FadeIn from './FadeIn';

const articles = [
  {
    category: 'Real Weddings',
    headline: 'Lauren & DJ: A Golden Hour Ceremony on the Sunset Terrace',
    excerpt:
      'As the sun dipped behind the Claremont foothills, Lauren and DJ exchanged vows before 180 guests on the estate\'s most breathtaking overlook.',
    img: 'https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Lauren-and-DJ-30.jpg',
    href: 'https://blog.paduaweddings.com',
  },
  {
    category: 'Planning Inspiration',
    headline: 'How to Design a Ceremony That Flows Seamlessly Into Your Reception',
    excerpt:
      'From the first walk down the aisle to the last dance, thoughtful event flow makes all the difference. Here\'s how Padua couples do it.',
    img: 'https://ik.imagekit.io/aeu02xvjgn/0302-CA-Padua-HIlls-Theatre-Wedding-Photography.jpg',
    href: 'https://blog.paduaweddings.com',
  },
  {
    category: 'Venue Guides',
    headline: 'A Complete Guide to the Padua Hills Estate: Spaces, Flow & What to Expect',
    excerpt:
      'Six distinct spaces. One historic estate. Here\'s everything you need to know about planning your wedding at Padua Hills Theatre.',
    img: 'https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Michelle-and-Joshua-922.jpg',
    href: 'https://blog.paduaweddings.com',
  },
];

const CategoryBadge = ({ label }) => (
  <span
    style={{
      display: 'inline-block',
      fontSize: '9px',
      letterSpacing: '0.25em',
      textTransform: 'uppercase',
      fontWeight: '700',
      color: '#A67C52',
      marginBottom: '12px',
      fontFamily: 'Montserrat, sans-serif',
    }}
  >
    {label}
  </span>
);

const ArticleCard = ({ article, idx }) => (
  <FadeIn delay={idx * 0.12}>
    <a
      href={article.href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', textDecoration: 'none', height: '100%' }}
    >
      <div
        style={{
          background: '#FCFAF6',
          border: '1px solid #D9CCBA',
          overflow: 'hidden',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          transition: 'box-shadow 0.4s ease, transform 0.4s ease',
          cursor: 'pointer',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.boxShadow = '0 20px 60px rgba(47,43,40,0.12)';
          e.currentTarget.style.transform = 'translateY(-4px)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.boxShadow = 'none';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        <div style={{ position: 'relative', overflow: 'hidden', height: '260px', flexShrink: 0 }}>
          <img
            src={article.img}
            alt={article.headline}
            loading="lazy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.8s ease',
              display: 'block',
            }}
            onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.05)')}
            onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
          />
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(to top, rgba(47,43,40,0.25) 0%, transparent 60%)',
            }}
          />
        </div>
        <div style={{ padding: '28px 28px 32px', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
          <CategoryBadge label={article.category} />
          <h3
            style={{
              fontFamily: '"Playfair Display", serif',
              fontSize: '20px',
              fontWeight: '400',
              color: '#2F2B28',
              lineHeight: '1.35',
              marginBottom: '14px',
            }}
          >
            {article.headline}
          </h3>
          <p
            style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '13px',
              fontWeight: '300',
              color: 'rgba(47,43,40,0.65)',
              lineHeight: '1.75',
              marginBottom: '24px',
              flexGrow: 1,
            }}
          >
            {article.excerpt}
          </p>
          <span
            style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '9px',
              letterSpacing: '0.25em',
              textTransform: 'uppercase',
              fontWeight: '700',
              color: '#6E7451',
              borderBottom: '1px solid #6E7451',
              paddingBottom: '3px',
              width: 'fit-content',
            }}
          >
            Read More
          </span>
        </div>
      </div>
    </a>
  </FadeIn>
);

const WeddingJournal = () => {
  return (
    <section
      id="journal"
      style={{ background: '#F6F1E8', scrollMarginTop: '120px' }}
    >
      {/* ── Hero ── */}
      <div
        style={{
          position: 'relative',
          overflow: 'hidden',
          minHeight: '520px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <img
          src="https://ik.imagekit.io/aeu02xvjgn/i-Wh5HSCQ-X3.jpg"
          alt="Padua Hills estate"
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center 40%',
          }}
        />
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to bottom, rgba(47,43,40,0.62) 0%, rgba(47,43,40,0.50) 100%)',
          }}
        />
        <div style={{ position: 'relative', zIndex: 10, padding: '100px 24px 80px', maxWidth: '780px', margin: '0 auto' }}>
          <FadeIn>
            <span
              style={{
                display: 'block',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '9px',
                letterSpacing: '0.45em',
                textTransform: 'uppercase',
                fontWeight: '700',
                color: '#A67C52',
                marginBottom: '24px',
              }}
            >
              The Padua Wedding Journal
            </span>
            <h2
              style={{
                fontFamily: '"Playfair Display", serif',
                fontSize: 'clamp(32px, 5vw, 58px)',
                fontWeight: '400',
                color: '#FCFAF6',
                lineHeight: '1.15',
                marginBottom: '20px',
              }}
            >
              Real Weddings, Planning Notes,<br />
              <span style={{ fontStyle: 'italic' }}>and Estate Inspiration</span>
            </h2>
            <p
              style={{
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '15px',
                fontWeight: '300',
                color: 'rgba(252,250,246,0.78)',
                lineHeight: '1.8',
                maxWidth: '520px',
                margin: '0 auto 36px',
              }}
            >
              Explore wedding ideas, venue stories, and planning inspiration from the foothills of Southern California.
            </p>
            <a
              href="https://blog.paduaweddings.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '9px',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                fontWeight: '700',
                color: '#FCFAF6',
                background: '#6E7451',
                padding: '16px 36px',
                textDecoration: 'none',
                transition: 'filter 0.3s ease',
              }}
              onMouseEnter={e => (e.currentTarget.style.filter = 'brightness(1.12)')}
              onMouseLeave={e => (e.currentTarget.style.filter = 'brightness(1)')}
            >
              Explore the Journal
            </a>
          </FadeIn>
        </div>
      </div>

      {/* ── Article Grid ── */}
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '80px 24px 80px' }}>
        <FadeIn>
          <div style={{ textAlign: 'center', marginBottom: '56px' }}>
            <span
              style={{
                display: 'block',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '9px',
                letterSpacing: '0.4em',
                textTransform: 'uppercase',
                fontWeight: '700',
                color: '#A67C52',
                marginBottom: '14px',
              }}
            >
              Latest from the Journal
            </span>
            <h3
              style={{
                fontFamily: '"Playfair Display", serif',
                fontSize: 'clamp(26px, 3.5vw, 40px)',
                fontWeight: '400',
                color: '#2F2B28',
                lineHeight: '1.2',
              }}
            >
              Stories Worth <span style={{ fontStyle: 'italic' }}>Remembering</span>
            </h3>
            <div
              style={{
                width: '60px',
                height: '1px',
                background: '#D9CCBA',
                margin: '20px auto 0',
              }}
            />
          </div>
        </FadeIn>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '28px',
          }}
        >
          {articles.map((article, idx) => (
            <ArticleCard key={idx} article={article} idx={idx} />
          ))}
        </div>

        <FadeIn delay={0.3}>
          <div style={{ textAlign: 'center', marginTop: '48px' }}>
            <a
              href="https://blog.paduaweddings.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '9px',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                fontWeight: '700',
                color: '#2F2B28',
                border: '1px solid #2F2B28',
                padding: '14px 32px',
                textDecoration: 'none',
                transition: 'background 0.3s ease, color 0.3s ease',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = '#2F2B28';
                e.currentTarget.style.color = '#FCFAF6';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#2F2B28';
              }}
            >
              View All Journal Posts
            </a>
          </div>
        </FadeIn>
      </div>

      {/* ── Bottom CTA ── */}
      <div
        style={{
          background: '#2F2B28',
          padding: '80px 24px',
          textAlign: 'center',
        }}
      >
        <FadeIn>
          <span
            style={{
              display: 'block',
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '9px',
              letterSpacing: '0.4em',
              textTransform: 'uppercase',
              fontWeight: '700',
              color: '#A67C52',
              marginBottom: '20px',
            }}
          >
            Ready to Begin
          </span>
          <h3
            style={{
              fontFamily: '"Playfair Display", serif',
              fontSize: 'clamp(28px, 4vw, 48px)',
              fontWeight: '400',
              color: '#FCFAF6',
              lineHeight: '1.2',
              marginBottom: '18px',
            }}
          >
            Planning a wedding at Padua?
          </h3>
          <p
            style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '14px',
              fontWeight: '300',
              color: 'rgba(252,250,246,0.6)',
              lineHeight: '1.8',
              maxWidth: '460px',
              margin: '0 auto 40px',
            }}
          >
            Start with inspiration, then schedule a private tour to experience the venue in person.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href="#contact"
              style={{
                display: 'inline-block',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '9px',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                fontWeight: '700',
                color: '#FCFAF6',
                background: '#6E7451',
                padding: '16px 32px',
                textDecoration: 'none',
                transition: 'filter 0.3s ease',
              }}
              onMouseEnter={e => (e.currentTarget.style.filter = 'brightness(1.15)')}
              onMouseLeave={e => (e.currentTarget.style.filter = 'brightness(1)')}
            >
              Book a Private Tour
            </a>
            <a
              href="https://blog.paduaweddings.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '9px',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                fontWeight: '700',
                color: '#FCFAF6',
                border: '1px solid rgba(252,250,246,0.35)',
                padding: '16px 32px',
                textDecoration: 'none',
                transition: 'border-color 0.3s ease, background 0.3s ease',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = 'rgba(252,250,246,0.7)';
                e.currentTarget.style.background = 'rgba(252,250,246,0.06)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = 'rgba(252,250,246,0.35)';
                e.currentTarget.style.background = 'transparent';
              }}
            >
              View Wedding Inspiration
            </a>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default WeddingJournal;